<template>
    <div class="d-block">
        <div class="flex">
            <vs-button  title="Seasons & Episodes" color="warning"  size="small" @click="$router.push({name:'editMovie',params:{id:episode.response.series_id},query:{tab:'seasons'}})"  class="mr-2" >All Seasons</vs-button>
            <vs-select  v-if="allEpisodes.length != 0" v-model="selectedItem" @change="goToItem">
            <vs-select-item :key="index" :value="item.id" :text="item.en_title" v-for="item, index in allEpisodes" />
        </vs-select>
        </div>


      
        <div class=" mb-4">
            <vs-tabs v-if="episode && episode.length != 0">
                <vs-tab label="Episode Info" icon="info">
                    <div class="bg-grid-color">
                        <div class=" d-center flex" v-if="season">
                            <img :src="`${season.series.poster}`" width="100" /> <br>
                            <span class="m-1">
                                <h2> {{ season.series.en_title }}</h2>
                                <hr>
                                <h6>{{ season.series.year }}</h6>
                                <h6>Season : {{ season.season_num }}</h6>
                            </span>
                        </div>
                        <vs-input-number v-model="episode.response.episode_num" label="Episode:" />
                        <ValidationObserver ref="form">
                            <form @submit.prevent="onSubmit">
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="English Name" rules="required" v-slot="{ errors }">
                                            <vs-input class="w-full" label-placeholder="English Name"
                                                v-model="episode.response.en_title" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="Arabic Name" rules="required" v-slot="{ errors }">
                                            <vs-input class="w-full" label-placeholder="Arabic Name"
                                                v-model="episode.response.ar_title" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="IMDB Rating" rules="required" v-slot="{ errors }">
                                            <vs-input class="w-full" v-model="episode.response.rating"
                                                label-placeholder="Imdb Rating" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="Imdb Link" rules=" " v-slot="{ errors }">
                                            <vs-input class="w-full" v-model="episode.response.imdb"
                                                label-placeholder="Imdb Link" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="Trailer" rules="" v-slot="{ errors }">
                                            <vs-input class="w-full" v-model="episode.response.trailer"
                                                label-placeholder="Trailer" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="Year" rules="required" v-slot="{ errors }">
                                            <vs-input class="w-full" label-placeholder="Year"
                                                v-model="episode.response.year" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <vs-input class="w-full" label-placeholder="Arabic tagline"
                                            v-model="episode.response.ar_tagline" />
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <vs-input class="w-full" label-placeholder="English tagline"
                                            v-model="episode.response.en_tagline" />
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="English Plot" rules="required" v-slot="{ errors }">
                                            <vs-textarea label="English Plot" v-model="episode.response.en_plot" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <ValidationProvider name="Arabic Plot" rules="required" v-slot="{ errors }">
                                            <vs-textarea label="Arabic Plot" v-model="episode.response.ar_plot" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="vx-row">


                                    <div class="vx-col md:w-1/2 w-full mt-5">
                                        <vSelect :filterable="true" :multiple="false" v-model="episode.response.rated"
                                            :options="['TV-G', 'TV-PG', 'TV-Y', 'TV-14', 'TV-MA', 'TV-Y7']"
                                            placeholder="Select Rated">

                                        </vSelect>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <vs-button @click="formSubmitted" class="m-3">Save </vs-button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </vs-tab>
                <vs-tab label="Videos" icon="high_quality">
                    <div class="con-tab-ejemplo m-5">
                        <Videos :movie="episode" @update="fetchEpisode"/>
                    </div>
                </vs-tab>
                <vs-tab label="Poster & Cover" icon="image">
                    <Poster :movie="episode" @update="fetchEpisode"/>
                </vs-tab>
                <vs-tab label="Options" icon="image">
                    <Options :movie="episode" @update="fetchEpisode"/>
                </vs-tab>




            </vs-tabs>

        </div>

    </div>
</template>

<script>
import {
    FormWizard,
    TabContent
} from 'vue-form-wizard'
import StarRating from 'vue-star-rating'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Videos from '../movies/Videos.vue'
import Poster from '../movies/poster.vue'
import Options from '../movies/options.vue'
export default {
    props: ['mData'],
    data() {
        return {
            firstName: "",
            imdbInfo: '',
            imdbId: '',
            status: false,
            loading: false,
            season: [],
            episode: [],
            allEpisodes: [],
            selectedItem: []
            /// other data....
        }
    },
    created() {
        //this.imdbData();
        this.fetchEpisode()


    },
    mounted() {
        var vm = this;
        // if (this.mData && this.mData.length != 0 && this.$store.state.languages.all != null) {
        //     this.episode.year = this.mData.response.year;
        //     this.episode.kind = this.mData.response.kind;
        //     this.episode.id = this.mData.response.id;
        //     this.episode.ar_title = this.mData.response.ar_title;
        //     this.episode.en_title = this.mData.response.en_title;
        //     this.episode.ar_plot = this.mData.response.ar_plot;
        //     this.episode.en_plot = this.mData.response.en_plot;
        //     this.episode.trailer = this.mData.response.trailer;
        //     this.episode.ar_tagline = this.mData.response.ar_tagline;
        //     this.episode.en_tagline = this.mData.response.en_tagline;
        //     this.episode.release_date = this.mData.response.released_date;
        //     this.episode.rating = this.mData.response.rating;
        //     this.episode.imdb = this.mData.response.imdb;
        //     this.episode.rated = this.mData.response.rated;
        //     //this.episode.season = this.mData.response.season;
        //     this.episode.en_plot = this.mData.response.en_plot;
        //     this.episode.ar_plot = this.mData.response.ar_plot;
        // }
    },
    watch: {
        'episode.response.episode_num': {
            handler(val) {
                this.sortData()
            },
            deep: true

        }
    },
    methods: {
        goToItem(){
            this.$router.push({ name: 'editEpisode', params: { id: this.selectedItem } });
            window.location.reload()
        },
        fetchAllEpisodes() {
            this.axios.get(`${this.$apiUrl}/v2/movies/fetch/episodes/${this.season.series.id}`).then(res => {
                this.allEpisodes = res.data;
            })
        },
        fetchEpisode() {
            this.loading = true;
            this.axios.get(`${this.$apiUrl}/v2/seasons/episodes/${this.$route.params.id}`).then(res => {
                this.episode = res.data;
                this.season = res.data.response.season
                this.fetchAllEpisodes()
                this.loading = false;
            })
        },
        sortData() {
            this.episode.response.en_title = `${this.season.series.en_title} S${this.season.season_num} E${this.episode.response.episode_num}`;
            this.episode.response.ar_title = `${this.season.series.ar_title} S${this.season.season_num} E${this.episode.response.episode_num}`;
            this.episode.response.rating = this.season.series.rating;
            this.episode.response.rated = this.season.series.rated;
            this.episode.response.year = this.season.series.year;
            this.episode.response.en_tagline = this.season.series.en_tagline;
            this.episode.response.ar_tagline = this.season.series.ar_tagline;
            this.episode.response.en_plot = this.season.series.en_plot;
            this.episode.response.ar_plot = this.season.series.ar_plot;
            this.episode.response.trailer = this.season.series.trailer;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.episode.posterFile = URL.createObjectURL(file);
        },
        validate() {


            return this.$refs.form.validate().then(result => {
                if (!result) {
                    return false;
                }
                this.formSubmitted();
                if (this.status) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        formSubmitted() {
            var _status = false;
            this.episode.status = false;
            const data = new FormData();
            this.$vs.loading()
            data.append('id', this.episode.response.id);
            data.append('comming_soon', this.episode.response.comming_soon);
            data.append('ar_title', this.episode.response.ar_title);
            data.append('season', this.season.id);
            data.append('en_title', this.episode.response.en_title);
            data.append('ar_tagline', this.episode.response.ar_tagline);
            data.append('en_tagline', this.episode.response.en_tagline);
            data.append('ar_plot', this.episode.response.ar_plot);
            data.append('en_plot', this.episode.response.en_plot);
            data.append('rating', this.episode.response.rating);
            data.append('rated', this.episode.response.rated);
            data.append('duration', this.episode.response.duration);
            data.append('trailer', this.episode.response.trailer);
            data.append('imdb', this.episode.response.imdb);
            data.append('poster', this.episode.response.poster);
            data.append('release_date', this.episode.response.release_date);
            data.append('year', this.episode.response.year);
            data.append('num', this.episode.response.episode_num);
            data.append('posterFile', this.episode.response.posterFile);
            this.axios.post(`${this.$apiUrl}/v2/seasons/episodes`, data).then(res => {
                this.$vs.loading.close()
                this.$emit('success', res.data)
                if (this.episode.response.id == 0) {
                    this.$vs.notify({
                        color: 'success',
                        title: 'episode Addedd',
                        text: '',
                        position: 'bottom-center'
                    })
                } else {
                    this.$vs.notify({
                        color: 'primary',
                        title: 'episode Updated',
                        text: '',
                        position: 'bottom-center'
                    })
                }
                this.$router.push({ name: 'editEpisode', params: { id: res.data.id } })
                this.episode.id = res.data.response.id;
                this.episode.status = true;


            }).catch(errors => {
                this.episode.status = false;
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'danger',
                    title: 'episode was not Addedd',
                    text: ''
                })
            });
            return _status;
        },
    },
    components: {
        FormWizard,
        TabContent,
        vSelect, StarRating, Videos, Poster,Options
    }
}
</script>
<style lang="scss">.vs-input {
    width: 90%;
    margin-top: 10px;
}</style>